import { ReactNode } from 'react'
import { Fade } from 'react-awesome-reveal'

import styles from './partner-link-group.module.scss'

export type PartnerLinkGroupProps = {
  children: ReactNode
}

export const PartnerLinkGroup = ({ children }: PartnerLinkGroupProps) => {
  return <div className={styles.container}><Fade triggerOnce delay={500}>{children}</Fade></div>
}
